import React from "react";

const ForwardModalItem = ({ type, cliente, isChecked, handleCheck }) => {
  return (
    <div className="modal__content__encaminhar__item">
      <div
        className={
          isChecked
            ? "checkbox checkbox--checked checkbox--checked-encaminhar active"
            : "checkbox checkbox--checked checkbox--checked-encaminhar"
        }
      >
        <div className="checkbox-container">
          <div className="checkbox-item" onClick={handleCheck}>
            <div className="check">
              <i className="material-icons">check</i>
            </div>
          </div>
        </div>
        <div className="modal__content__encaminhar__item__img">
          <img src="build/images/cliente.svg" alt="" />
        </div>
        <p className="modal__content__encaminhar__item__text">
          {type === "single" ? cliente : "Grupo 1"}
        </p>
      </div>
    </div>
  );
};

export default ForwardModalItem;
